import { ArcanaIdentities } from '../arcana-identities';
import { ARCANA_IMAGE_URI } from '../arcana-images';
import { ARCANA_DESCRIPTIONS } from '../data/arcana-descriptions';
import type { DeckDefinition } from '../../../types/deck';

/**
 * The Thoth deck — the engine's original and default deck. Images are the
 * hot-linked Crowley-Harris scans already in use; text is the existing
 * Book-of-Thoth-aligned copy. Nothing new here, just re-exposed under the
 * deck registry so the switcher can treat all three decks uniformly.
 */
export const THOTH: DeckDefinition = {
    id: 'thoth',
    label: 'Thoth',
    header: {
        byline: "Aleister Crowley's",
        title: 'Thoth Tarot',
        slogan: 'Find the colour of your soul...',
    },
    images: ARCANA_IMAGE_URI,
    descriptions: ARCANA_DESCRIPTIONS,
};

// Keep the identity table referenced so tree-shaking never drops the enum
// before the deck files that key off it are evaluated.
void ArcanaIdentities;
